import classes from "../../styles/components/statusButtons.module.scss";

function StatusHackathonProjectButton() {
    return(
        <button className={`${classes.hackathonProject} ${classes.button}`}>● hackathon project</button>
    );
}

export default StatusHackathonProjectButton;